const ContentLg = {
    SIGNUP_LOGIN: "Login / Sign up",
    PROF_LOGIN: "Discover Jobs",
    REC_LOGIN: "Hire Designers & Developers",
    REC_LANDING_SUB_HDR: "Hire top-notch designers & developers",
    PROF_LANDING_SUB_HDR: "Find the best jobs in the industry",
    FREELANCER_LANDING_SUB_HDR: "Recruiter",
    CANDIDATE_LANDING_SUB_HDR: "Candidate Login",
    REC_LOGIN_TITLE: "Welcome Back",
    RESET_PSWD: "Reset password",
    RESET_PSWD_SUB_HDR: "Password update link will be sent to below Email ID",
    REC_SUCCESS_HDR_SIGNUP: "Verify your Email ID",
    REC_SUCCESS_MSG_SIGNUP: "Verification link has been sent to the below Email ID.",
    REC_SUCCESS_HDR_RESET_PSWD: "Verify your Email ID",
    REC_SUCCESS_MSG_RESET_PSWD: "A password reset link has been sent to the mentioned Email ID.",
    REC_EMAIL_PH: "Enter your company email id here",
    FREELANCER_EMAIL_PH: "Enter your email ID here...",
    REC_PSWD_PH: "Enter your password…",
    BOTTOM_LAYER_FOR_PROFESSIONAL: "Looking to hire top talent?",
    BOTTOM_LAYER_ACTION_FOR_PROFESSIONAL: "I AM A RECRUITER",
    BOTTOM_LAYER_FOR_RECRUITER: "Not a Recruiter or Hiring Manager?",
    BOTTOM_LAYER_ACTION_FOR_RECRUITER: "I AM LOOKING FOR A JOB",
    PROFESSIONAL_EMAIL_ID_EXISTS: "Your already have a existing account",
    //------------Freelancer----------------------------
    FREELANCER_LOGIN: "Freelancer login",
    FREELANCER_LOGIN_TITLE: "frelancer login title",
    FREELANCER_SUCCESS_HDR_SIGNUP: "Verify your email ID",
    FREELANCER_SUCCESS_MSG_SIGNUP: "Verification link has been sent to the below email ID.",
    FREELANCER_SUCCESS_HDR_RESET_PSWD: "Verify your email ID",
    FREELANCER_SUCCESS_MSG_RESET_PSWD: "A password reset link has been sent to the mentioned email ID.",
    BTN: {
        BACK: "Back",
        NEXT: "Next",
        CANCEL: "Cancel",
        FORGOT_PSWD: "Forgot Password?",
        SUBMIT: "Submit",
        LOGIN: "Login",
        SEND_EMAIL: "Send Email"
    },

    MSG: {
        INVALID_EMAIL: "Invalid Email ID",
        PUBLIC_DOMAIN: "Only Official Email ID Allowed",
        INVALID_PSWD: "Only  ! @ # $ % & *  symbols allowed",
        INVALID_MIN_PSWD: "Use minimum 6 character password",
        WRONG_PSWD: "Password Mismatch",
        INVITE_ONLY: "This is invite only. Please contact support@talentxo.com"
    },

    PSWD_INPUT_TITLE: "Only  ! @ # $ % & *  symbols allowed"
};

export default ContentLg;



// WEBPACK FOOTER //
// ./src/ContentLg.js